import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { MailCheck, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/newsletter`, { email: email.trim() });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error("That email doesn't look right. Try again?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="border-b-2 border-[#0A0A0A] bg-[#FFD700] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl lg:text-6xl">
            Get the drop <span className="text-[#FF2A54]">first</span>
          </h2>
          <p className="mt-4 text-base font-medium text-[#0A0A0A]/80 sm:text-lg">
            One short email when new candy and toys land. No spam, all sugar.
          </p>
          <form onSubmit={subscribe} data-testid="newsletter-form" className="mt-8 flex flex-col gap-4 sm:flex-row">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              data-testid="newsletter-email-input"
              className="hard-shadow w-full flex-1 rounded-full border-2 border-[#0A0A0A] bg-white px-6 py-4 text-base font-medium outline-none placeholder:text-[#4A4A4A]/60 focus:ring-4 focus:ring-[#FF2A54]/40"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-button"
              className="hard-shadow hard-shadow-hover inline-flex items-center justify-center gap-2 rounded-full border-2 border-[#0A0A0A] bg-[#FF2A54] px-8 py-4 font-display text-base font-extrabold uppercase text-white disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <MailCheck className="h-5 w-5" />}
              Sign me up
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
}
